import { render, staticRenderFns } from "./fileCollect.vue?vue&type=template&id=4e85b004"
import script from "./fileCollect.vue?vue&type=script&lang=js"
export * from "./fileCollect.vue?vue&type=script&lang=js"
import style0 from "./fileCollect.vue?vue&type=style&index=0&id=4e85b004&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports